export const API_HOST = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8383';
const TOKEN_KEY = 'billygo_token';

/**
 * 获取存储的 Token
 */
export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

/**
 * 获取请求头 (JWT Token)
 */
export function getAuthHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  const token = getToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
}

/**
 * 通用 API 请求方法
 */
export async function apiRequest<T = any>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const token = getToken();

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string> || {}),
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_HOST}${path}`, {
    ...options,
    headers,
  });

  // 处理 401 未授权
  if (response.status === 401) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('billygo_user');
    window.location.href = '/login';
    throw new Error('登录已过期，请重新登录');
  }

  // 处理非 OK 响应
  if (!response.ok) {
    const text = await response.text();
    let errorMsg = `请求失败 (${response.status})`;
    try {
      const json = JSON.parse(text);
      errorMsg = json.msg || json.message || json.error || errorMsg;
    } catch {
      if (text) errorMsg = text;
    }
    throw new Error(errorMsg);
  }

  return response.json();
}

/**
 * GET 请求
 */
export function apiGet<T = any>(path: string): Promise<T> {
  return apiRequest(path, { method: 'GET' });
}

/**
 * POST 请求
 */
export function apiPost<T = any>(path: string, body: any): Promise<T> {
  return apiRequest(path, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
